import { deletedUsername } from "src/utils/users/users";
import { QueryResult } from "@apollo/client";
import { logger } from "src/utils/logger/browser";

import { ApiParams, getListMyQueriesVariables } from "./listMyQueries";

import {
  useListMyQueriesQuery,
  ListMyQueriesQuery,
} from "src/gql/codegen/graphql";

import type { SessionWithUser } from "src/utils/users/types";

type HookResult = QueryResult<ListMyQueriesQuery>;

export default function useListMyQueries(
  apiParams: ApiParams,
  session: SessionWithUser
): HookResult {
  const { owner } = apiParams.filter;
  if (owner && owner.type === "user" && owner.handle === deletedUsername) {
    delete apiParams.filter.owner;
  }

  return useListMyQueriesQuery({
    /*
     * We now only show queries owned by the user/team selected in the
     * ContextSwitcher.
     *
     * If the owner filter is not set, we are still fetching session or
     * teams to determine owner. Don't fetch owned queries until the
     * owner filter is set.
     */
    skip: !owner,
    context: { session }, // Needs session to get private queries
    variables: getListMyQueriesVariables(apiParams, session),
    fetchPolicy: "cache-first",
    onError: logger.error,
  });
}
